<template>
  <div id="pesquisa">

    <div v-if="showError">
      <PesquisaMensagem
        v-if="showError === 409"
        icone="img_helper_answered"
        titulo="Pesquisa já respondida"
        descricao="Tudo certo por aqui. Você já respondeu esta pesquisa e não precisa fazer mais nada."
        :height="'220'"
        :width="'220'"
      />
      <PesquisaMensagem
        v-else-if="showError === 403"
        icone="img_helper_teleconsulta2"
        titulo="Pesquisa expirada"
        descricao="Desculpe, mas a pesquisa que você tentou acessar não está mais disponível."
        :height="'220'"
        :width="'220'"
      />
      <PesquisaMensagem
        v-else
        icone="img_helper_empty_default"
        titulo="Pesquisa Não encontrada"
        descricao="Não conseguimos encontrar a pesquisa desejada."
        :height="'220'"
        :width="'220'"
      />
    </div>
    <div
      v-else-if="isStepQuestionario"
      v-show="!loading"
      id="survey-render"
    />

    <div v-else-if="stepNome === stepsTipos.encerramento">
      <PesquisaMensagem
        icone="img_helper_success"
        :titulo="stepAtual.parametros.titulo"
        :descricao="stepAtual.parametros.descricao"
        :height="'220'"
        :width="'220'"
      />
    </div>
    <loading-modal
      :show="loading"
      :sucesso="false"
      texto="Carregando..."
    />
  </div>
</template>
<script>

import { renderSurvey } from '@mobilesaude/form-builder-sdk'
import { ConfiguradorResource } from '@/API'
import { mapGetters, mapState } from 'vuex'
import PesquisaMensagem from '@/components/Pesquisa/PesquisaMensagem.vue'
import LoadingModal from '@/components/LoadingModal/LoadingModal'

const stepsTiposEnum = {
  questionario: 'questionario',
  encerramento: 'encerramento'
}

export default {
  name: 'Pesquisa',
  components: {
    LoadingModal,
    PesquisaMensagem
  },
  props: {
    idTemplatePesquisa: {
      type: String
    },
    pesquisaEnvioId: {
      type: String
    },
    canal: {
      type: String
    },
    templatePesquisa: {
      type: Object
    },
    statusCode: {
      type: Number
    }
  },
  data () {
    return {
      form: null,
      showError: null,
      pesquisaTemplate: null,
      step: -1,
      stepsTipos: { ...stepsTiposEnum },
      stepData: [],
      loading: true
    }
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiPesquisa']),
    ...mapGetters('SetupApp', ['estiloFormBuilder']),
    stepAtual () {
      if (this.step === -1 || !this.pesquisaTemplate) {
        return {}
      }

      return this.pesquisaTemplate.steps[this.step] || {}
    },
    stepNome () {
      return this.stepAtual.tipo
    },
    questionario () {
      return this.pesquisaTemplate && this.pesquisaTemplate.steps.find((v) => v.tipo === this.stepsTipos.questionario)
    },
    isStepQuestionario () {
      return this.stepNome === this.stepsTipos.questionario
    }
  },
  methods: {
    async init () {
      this.loading = true
      await this.getConfig()
      this.loading = false
    },
    nextStep () {
      if (this.stepNome === this.stepsTipos.encerramento) {
        return
      }

      this.step = this.step + 1

      if (this.stepNome === this.stepsTipos.encerramento) {
        this.salvarQuestionario()
      }
    },
    async getConfig () {
      if (this.templatePesquisa) {
        this.pesquisaTemplate = this.templatePesquisa
        this.showError = this.statusCode
      } else {
        const template = await ConfiguradorResource.getTemplatePesquisa({
          bundle: this.bundle,
          pesquisaEnvioId: this.pesquisaEnvioId
        })

        if (template.statusCode !== 200) {
          this.showError = template.statusCode
          this.loading = false
          return null
        }

        this.pesquisaTemplate = template
      }

      this.nextStep()

      if (this.isStepQuestionario) {
        setTimeout(() => {
          this.initForm(this.questionario.idRecurso)
        }, 500)
      }
    },
    async salvarQuestionario () {
      const payload = {
        pesquisaEnvioId: this.pesquisaEnvioId,
        clientKey: this.config.aplicacao.clientKey,
        canal: this.canal,
        steps: this.stepData
      }

      await this.apiPesquisa.enviarPesquisa({
        payload,
        headers: {},
        loading: true,
        handlerErrorIgnore: true
      })
    },
    initForm (idSurvey) {
      let params = {
        identifier: 'survey-render',
        clientKey: this.config.aplicacao.clientKey,
        idSurvey,
        'colors': { ...this.estiloFormBuilder }
      }
      this.form = renderSurvey(params)

      this.form.on('FORM_VALIDATE_ALL', (params) => {
        this.stepData.push({
          tipo: this.stepsTipos.questionario,
          idRecurso: this.questionario.idRecurso,
          data: params.data
        })
        this.nextStep()
      })

      this.form.on('LOADING', (response) => {
        this.loading = response.loading
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
<style lang="less">
#pesquisa {
  max-width: 600px;
  min-height: 500px;
  background-color: transparent;
  .sucesso-pesquisa-header {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
  }
  .sucesso-pesquisa-titulo {
    max-width: 250px;
  }
  .sucesso-pesquisa-texto {
    max-width: 250px;
  }
}
</style>
